import { Link } from 'react-router-dom';
import '../assets/public-home.css';
import '../assets/theme-content.css';

export function PublicHome() {
    return (
        <div className="public-home theme-content">
            <div className="public-home-inner">
                <section className="public-home-hero" aria-labelledby="public-home-title">
                    <div>
                        <p className="public-home-eyebrow">Triad Teacher Training</p>
                        <h1 id="public-home-title" className="public-page-title">Your next step<br />as an English teacher.</h1>
                        <p className="public-home-lead">
                            Develop your teaching practice with products 
                            by Olha Popivnenko, teacher trainer, curriculum designer and materials developer.
                        </p>
                        <div className="public-home-actions">
                            <Link to="/products" className="public-home-button">Explore products <i className="pi pi-arrow-right" aria-hidden="true" /></Link>
                        </div>
                        <p className="public-home-note">For teachers building their foundations and those ready to take their practice further.</p>
                    </div>
                    <aside className="public-home-trainer" aria-labelledby="public-home-trainer-title">
                        <span className="public-home-trainer-mark" aria-hidden="true">OP</span>
                        <p className="public-home-eyebrow">Meet your trainer</p>
                        <h2 id="public-home-trainer-title">Olha Popivnenko</h2>
                        <p>Founder of Triad Teacher Training and creator of every product on this website.</p>
                        <ul className="public-home-credentials">
                            <li><strong>CELTA trainer</strong><span>Experience in teacher development</span></li>
                            <li><strong>Full DELTA</strong><span>Distinction in Teaching</span></li>
                            <li><strong>MA Linguistics</strong><span>University of Manchester, Distinction</span></li>
                        </ul>
                        <Link to="/about" className="public-home-text-link">Get to know Olha <i className="pi pi-arrow-right" aria-hidden="true" /></Link>
                    </aside>
                </section>

                <section className="public-home-section" aria-labelledby="public-home-paths-title">
                    <p className="public-home-eyebrow">Choose your next step</p>
                    <h2 id="public-home-paths-title">What would you like to work on?</h2>
                    <div className="public-home-paths">
                        <article className="public-home-path">
                            <i className="pi pi-book public-home-path-icon" aria-hidden="true" />
                            <h3>Develop your teaching practice</h3>
                            <p>Explore teacher training products focused on methodology, lesson planning and the use of learning materials. Choose a product that fits your experience and goals.</p>
                            <Link to="/products" className="public-home-text-link">Browse teacher training products <i className="pi pi-arrow-right" aria-hidden="true" /></Link>
                        </article>
                    </div>
                </section>

                <section className="public-home-approach public-home-section" aria-labelledby="public-home-approach-title">
                    <div>
                        <p className="public-home-eyebrow">Experience behind the training</p>
                        <h2 id="public-home-approach-title">Teaching, training<br />and materials design.</h2>
                    </div>
                    <div>
                        <p>Olha’s work brings together English teaching, CELTA training, DELTA Module 1 preparation and Module 3 teaching. Her teaching experience spans online and face-to-face classes, groups and individual learners.</p>
                        <p>She has also designed product programmes and teaching materials for online language schools in Ukraine, Italy and Germany. Triad brings these areas of experience together to support your professional development.</p>
                        <Link to="/about" className="public-home-text-link">Read about olha’s background <i className="pi pi-arrow-right" aria-hidden="true" /></Link>
                    </div>
                </section>

                <section className="public-home-section" aria-labelledby="public-home-start-title">
                    <p className="public-home-eyebrow">Getting started</p>
                    <h2 id="public-home-start-title">Find the right fit for you.</h2>
                    <ol className="public-home-steps">
                        <li><span aria-hidden="true">01</span><h3>Explore your options</h3><p>Browse products to see what matches your teaching context and development goals.</p></li>
                        <li><span aria-hidden="true">02</span><h3>Read the details</h3><p>Check the product description and price.</p></li>
                        <li><span aria-hidden="true">03</span><h3>Take your next step</h3><p>Sign in or create an account to purchase an available product.</p></li>
                    </ol>
                </section>

                <section className="public-home-closing" aria-labelledby="public-home-closing-title">
                    <div><h2 id="public-home-closing-title">Make space for your own development.</h2><p>Explore what Triad Teacher Training can offer you.</p></div>
                    <Link to="/products" className="public-home-button">Explore products <i className="pi pi-arrow-right" aria-hidden="true" /></Link>
                </section>
                <footer className="public-home-footer">
                    <span>Triad Teacher Training · Olha Popivnenko (olgapopivnenko35@gmail.com)</span>
                    <nav aria-label="Homepage footer"><Link to="/about">About</Link><Link to="/terms-of-use">Terms &amp; conditions</Link><Link to="/refund-policy">Refund &amp; cancellation policy</Link><Link to="/privacy-policy">Privacy policy</Link></nav>
                </footer>
            </div>
        </div>
    );
}
